if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            console.log(parsedState)
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              // Even on a stock-limit error Shopify may have partially added
              // the item (capped to available qty). Fetch the live cart count
              // and update the header bubble so it reflects the actual cart.
              this.refreshCartCount();
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
            }
            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }
            document
              .querySelector(".product-form__error-message-wrapper")
              ?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
          // Show the beautiful popup alert instead of the inline message
          StockAlertPopup.show(errorMessage);
        }
      }

      // Fetches the live cart item_count and updates the header counter bubble.
      // Called after a stock-limit error so the count stays in sync without a
      // full page reload.
      refreshCartCount() {
        fetch(`${routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cart) => {
            // Update every element that shows the cart count in the header.
            // The header renders two instances (sticky + non-sticky) each
            // containing a <span id="cart-notification-count"> and a
            // visually-hidden <span> alongside it.
            document
              .querySelectorAll('#cart-notification-count')
              .forEach((el) => {
                const isMaxed = cart.item_count > 99;
                el.textContent = isMaxed ? '99+' : cart.item_count;
                // Keep badge width in sync with the displayed value
                const bubble = el.closest('.cart-count-bubble');
                if (bubble) bubble.classList.toggle('is-maxed', isMaxed);
              });

            // Also update the visually-hidden accessible labels that sit
            // directly after the count span inside .cart-count-bubble.
            document
              .querySelectorAll('.cart-count-bubble')
              .forEach((bubble) => {
                const hiddenSpan = bubble.querySelector('.visually-hidden');
                if (hiddenSpan && window.cartStrings?.cartCount) {
                  hiddenSpan.textContent = window.cartStrings.cartCount.replace(
                    '[count]',
                    cart.item_count
                  );
                }
              });
          })
          .catch(() => {
            // Non-critical: count will correct itself on next full render.
          });
      }
    }
  );
}

/**
 * StockAlertPopup
 * A singleton popup that replaces the inline product-form error message.
 * Shows a styled modal with the stock-limit message and a "View Cart" button
 * that reloads the page so the cart reflects the actual quantities added.
 */
const StockAlertPopup = (() => {
  let overlay = null;

  function build() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.id = 'stock-alert-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'stock-alert-title');
    overlay.innerHTML = `
      <div class="stock-alert__backdrop"></div>
      <div class="stock-alert__box">
        <div class="stock-alert__icon-wrap">
          <svg class="stock-alert__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"/>
            <path d="M12 7v5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="16.5" r="1" fill="currentColor"/>
          </svg>
        </div>
        <h2 id="stock-alert-title" class="stock-alert__title">Stock Limit Reached</h2>
        <p class="stock-alert__message"></p>
        <div class="stock-alert__actions">
          <button class="stock-alert__btn stock-alert__btn--primary" id="stock-alert-view-cart">
            Okay!
          </button>
        </div>
      </div>
    `;

    // Dismiss on backdrop click — disabled: user must click Update to close
    // overlay.querySelector('.stock-alert__backdrop').addEventListener('click', hide);

    // View Cart → reload page
    overlay.querySelector('#stock-alert-view-cart').addEventListener('click', () => {
      window.location.reload();
    });

    // Escape key dismiss — disabled: user must click Update to close
    // document.addEventListener('keydown', (e) => {
    //   if (e.code === 'Escape' && overlay && overlay.classList.contains('is-visible')) {
    //     hide();
    //   }
    // });

    document.body.appendChild(overlay);
  }

  function show(message) {
    build();
    overlay.querySelector('.stock-alert__message').textContent = message;
    // Trigger paint before adding class so CSS transition runs
    overlay.offsetHeight;
    overlay.classList.add('is-visible');
    // Trap focus on the primary button
    setTimeout(() => {
      overlay.querySelector('#stock-alert-view-cart').focus();
    }, 50);
  }

  function hide() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
  }

  return { show, hide };
})();
